export default "__VITE_ASSET__22QY7URR__"